import fetch from "auth/FetchInterceptor";

const relatoriosPowerBiService = {};

relatoriosPowerBiService.getAll = function () {
	return fetch({
		url: "/v1/rest/relatorios-power-bi",
		method: "get",
	});
};

relatoriosPowerBiService.getById = function (id) {
	return fetch({
		url: "/v1/rest/relatorios-power-bi/" + id,
		method: "get",
	});
};
relatoriosPowerBiService.post = function (data) {
	return fetch({
		url: "/v1/rest/relatorios-power-bi",
		method: "post",
		data: data,
	});
};

relatoriosPowerBiService.put = function (id, data) {
	return fetch({
		url: "/v1/rest/relatorios-power-bi/" + id,
		method: "put",
		data: data,
	});
};
relatoriosPowerBiService.delete = function (id) {
	return fetch({
		url: "/v1/rest/relatorios-power-bi/" + id,
		method: "delete",
	});
};

export default relatoriosPowerBiService;
